import { PBTNotificationsAction, PBTNotificationsActionType } from './action-types';
import type { IPBTNotificationsState } from './types';

// PBT notifications reducer name
export const pbtNotificationsReducerName = 'pbtNotificationsReducer';

// PBT notifications initial state
export const pbtNotificationsInitialState: IPBTNotificationsState = {
  notifications: [],
  unreadCount: 0,
  isLoading: false,
  hasError: false,
  errorMessage: null,
};

// PBT notifications reducer
export function pbtNotificationsReducer(
  prev: IPBTNotificationsState = pbtNotificationsInitialState,
  action: PBTNotificationsAction): IPBTNotificationsState {
  switch (action.type) {

    case PBTNotificationsActionType.REQUEST_NOTIFICATIONS:
      return {
        ...prev,
        isLoading: true,
        hasError: false,
        errorMessage: null,
      };

    case PBTNotificationsActionType.RECEIVE_NOTIFICATIONS:
      return {
        ...prev,
        isLoading: false,
        hasError: false,
        errorMessage: null,
        notifications: action.data,
        unreadCount: action.unreadCount,
      };

    case PBTNotificationsActionType.ERROR_NOTIFICATIONS:
      return {
        ...prev,
        isLoading: false,
        hasError: true,
        errorMessage: action.errorMessage ?? null,
      };

    case PBTNotificationsActionType.MARK_READ_SUCCESS: {
      const wasUnread = prev.notifications.some(
        (n) => n.notificationId === action.notificationId && !n.isRead
      );
      return {
        ...prev,
        unreadCount: wasUnread ? Math.max(0, prev.unreadCount - 1) : prev.unreadCount,
        notifications: prev.notifications.map((n) =>
          n.notificationId === action.notificationId ? { ...n, isRead: true } : n
        ),
      };
    }

    case PBTNotificationsActionType.MARK_ALL_READ_SUCCESS:
      return {
        ...prev,
        unreadCount: 0,
        notifications: prev.notifications.map((n) => ({ ...n, isRead: true })),
      };

    default:
      return prev;
  }
}
